import { parse } from 'date-fns'
import { AnonymousData } from '../../rest/decorators/mapped'

export interface ManagerVersion {
  commit: string
  time: Date
}

export const mapVersion = (data: AnonymousData): ManagerVersion => {
  const {
    data: { revision, time },
  } = data as unknown as { data: { revision: string; time: string } }
  return {
    commit: revision as string,
    time: parse(time as string, 'yyyyMMddHHmmss', new Date()),
  }
}

export const parseVersion = (signature: string): ManagerVersion => {
  const [commit, time] = signature.split('-')
  return { commit, time: parse(time, 'yyyyMMddHHmmss', new Date()) }
}
